import {
  AllocationPaymentItem as IAllocationPaymentItem,
  AllocationPaymentTargetAccount as IAllocationPaymentTargetAccount,
  BankTransferInfo as IBankTransferInfo,
  DepositPaymentOption as IDepositPaymentOption,
  DepositPaymentTargetAccount as IDepositPaymentTargetAccount,
  GetAllocationPaymentDetailsResponse as IGetAllocationPaymentDetailsResponse,
  GetDepositPaymentDetailsResponse as IGetDepositPaymentDetailsResponse,
  GetTransferPaymentDetailsResponse as IGetTransferPaymentDetailsResponse,
  TransferPaymentItem as ITransferPaymentItem,
  TransferPaymentTargetAccount as ITransferPaymentTargetAccount,
  ResponseMessage,
  ResponseMessageMsgTypeEnum,
} from '@eih-netbroker/api-payment';

export enum CashAction {
  Deposit = 'Deposit',
  Transfer = 'Transfer',
  Allocation = 'Allocation',
}

export type CashActionType = 'deposit' | 'transfer' | 'allocation';

export enum CashDepositSource {
  Internal = 'Internal',
  External = 'External',
}

export enum CashActionSubmitResponseTypeEnum {
  Confirmed = 'confirmed',
  Submitted = 'submitted',
}

export type BankTransferInfo = IBankTransferInfo;

export type DepositPaymentOption = IDepositPaymentOption;

export type GetDepositPaymentDetailsResponse = IGetDepositPaymentDetailsResponse;

export type DepositPaymentTargetAccount = IDepositPaymentTargetAccount;

export type GetTransferPaymentDetailsResponse = IGetTransferPaymentDetailsResponse;

export type TransferPaymentTargetAccount = ITransferPaymentTargetAccount;

export type TransferPaymentItem = ITransferPaymentItem;

export type GetAllocationPaymentDetailsResponse = IGetAllocationPaymentDetailsResponse;

export type AllocationPaymentTargetAccount = IAllocationPaymentTargetAccount;

export type AllocationPaymentItem = IAllocationPaymentItem;

export type CashActionResponseMessage = ResponseMessage;

export type CashActionResponseMessageType = ResponseMessageMsgTypeEnum;
